import Vue from 'vue'
import VueMeta from 'vue-meta';
import App from './App.vue'
import router from './router'
import vueSmoothScroll from 'vue2-smooth-scroll'
import Vuelidate from "vuelidate"
import './plugins/globals'
import store from "./store"
import VueGtag from 'vue-gtag'

Vue.use(VueMeta, {
  // keyName: 'head',
  refreshOnceOnNavigation: false
});
Vue.use(Vuelidate);
Vue.use(vueSmoothScroll)
Vue.use(VueGtag, {
  config: { 
    id: process.env.VUE_APP_SRC_GTAG,
    params: {
      send_page_view: false
    }
  }
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
